import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import React from "react";
import { Col, Row } from "react-bootstrap";
var BottomInputMsg = function (props) {
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, null, !props.showlink ? (React.createElement(Col, { lg: 12, className: props.parentClass },
            React.createElement("span", { className: "DMSansNormal_12_400 txt_secondary-gray " }, props.message))) : (React.createElement(Col, { lg: 12 },
            React.createElement(EdButton, { btnTyp: "midnight-blue-underline", type: "button", className: "DMSansNormal_12_400", value: props.message, onClick: function () {
                    props.callBackFunction ? props.callBackFunction() : function () { };
                } }))))));
};
export default BottomInputMsg;
